import { GlobalStyles } from '@bigcommerce/big-design';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createGlobalStyle, ThemeProvider } from 'styled-components';

import App from './App';
import kynetikTheme, { globalStyleOverrides } from './styles/theme';

// Global style overrides for Kynetik branding
const KynetikGlobalStyles = createGlobalStyle`
  ${globalStyleOverrides}
`;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={kynetikTheme}>
      <GlobalStyles />
      <KynetikGlobalStyles />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
